module.exports = __webpack_public_path__ + "static/media/IMG_0742.b7914d9b.JPG";